import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { convertFromRaw, EditorState } from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createLinkifyPlugin from "@draft-js-plugins/linkify";
import { FormattedMessage } from "react-intl";
import createInlineToolbarPlugin from "@draft-js-plugins/inline-toolbar";
import createVideoPlugin from "@draft-js-plugins/video";
import createImagePlugin from "@draft-js-plugins/image";
import createLinkPlugin from "@draft-js-plugins/anchor";
import "@draft-js-plugins/image/lib/plugin.css";
import linkStyles from "./linkStyle.module.css";
import "@draft-js-plugins/linkify/lib/plugin.css";
import "@draft-js-plugins/anchor/lib/plugin.css";

const imagePlugin = createImagePlugin();

const videoPlugin = createVideoPlugin();

const linkPlugin = createLinkPlugin({
  theme: linkStyles,
  placeholder: "http://…",
  linkTarget: "__blank",
});

const inlineToolbarPlugin = createInlineToolbarPlugin();
const linkifyPlugin = createLinkifyPlugin({
  target: "_blank",
  component(props) {
    // eslint-disable-next-line no-alert, jsx-a11y/anchor-has-content
    return <a {...props} onClick={() => alert("Clicked on Link!")} />;
  },
});

const plugins = [videoPlugin, imagePlugin, linkPlugin, linkifyPlugin];

class Content extends React.Component {
  state = {
    editorState: this.props.editorState,
  };
  onChange = (editorState) => {
    this.setState({ editorState });
  };
  render() {
    return (
      <StyledEditor
        editorState={this.state.editorState}
        readOnly
        ref={(element) => {
          this.editor = element;
        }}
        onChange={this.onChange}
        plugins={plugins}
      />
    );
  }
}

const ContentWrapper = ({
  headerPicture,
  headerTop,
  summary,
  bodyPicture,
  content,
  type,
  isEnglish,
}) => {
  const hasEditorState = content.charAt(0) === "{";
  const [editorState, setEditorState] = useState();

  useEffect(() => {
    const state = content
      ? EditorState.createWithContent(convertFromRaw(JSON.parse(content)))
      : EditorState.createEmpty();
    setEditorState(state);
  }, [content]);

  return (
    <Container>
      <CoverNewsItem style={{ backgroundImage: `url(${headerPicture})` }}>
        {(type === "project" || type === "aboutUs") && (
          <CoverText>{headerTop}</CoverText>
        )}
      </CoverNewsItem>
      <Body>
        {type === "newsItem" && (
          <div>
            <NewsItemHeader>{headerTop}</NewsItemHeader>
            <Summary>{summary}</Summary>
          </div>
        )}{" "}
        {hasEditorState ? (
          editorState && (
            <Content
              editorState={editorState}
              readOnly
              onChange={() => {}}
              plugins={plugins}
              // ref="editor"
            />
          )
        ) : (
          <p style={{ marginBottom: "15px" }}>{content}</p>
        )}
        {bodyPicture && <BodyImage src={bodyPicture} alt="bodyPicture" />}
      </Body>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-bottom: 32px;
`;

const CoverNewsItem = styled.div`
  width: 1100px;
  height: 550px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  object-fit: contain;
  margin-bottom: 32px;
  background-repeat: no-repeat;
  @media only screen and (min-width: 275px) and (max-width: 480px) {
    width: 100%;
    object-fit: cover;
    height: 226px;
    background-size: cover;
    background-repeat: no-repeat;
  }
`;

const StyledEditor = styled(Editor)`
  figure {
    width: 100%;
    margin: 0px;
    max-width: 100%;
    img {
      width: 100%;
    }
  }
  img {
    width: 300px;
  }
  iframe {
    width: 100% !important;
  }
`;

const CoverText = styled.h1`
  font-family: "Nunito Sans";
  font-size: 56px;
  font-weight: 600;
  line-height: 1.07;
  letter-spacing: 0;
  text-align: center;
  color: #ffffff;
  text-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
  @media only screen and (min-width: 275px) and (max-width: 480px) {
    font-family: "Nunito Sans";
    font-size: 24px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0;
    text-align: center;
    color: #ffffff;
  }
`;

const Body = styled.div`
  width: 750px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  font-family: "Nunito Sans";
  font-size: 18px;
  letter-spacing: 0;
  text-align: center;
  color: #333333;
  text-align: left;
  figure {
    width: 100%;
    margin: 0px;
    max-width: 100%;
    img {
      width: 100%;
    }
  }
  img {
    width: 300px;
  }
  @media only screen and (min-width: 275px) and (max-width: 480px) {
    width: 90%;
  }
`;

const NewsItemHeader = styled.p`
  margin-bottom: 25px;
  font-family: "Nunito Sans";
  font-size: 23px;
  font-weight: 600;
  color: #007ec9;
  @media only screen and (min-width: 275px) and (max-width: 480px) {
    font-size: 18px;
  }
`;

const Summary = styled.p`
  font-family: "Nunito Sans Extra-Light Italic";
  font-style: italic;
  font-weight: 300;
`;

const BodyImage = styled.img`
    width: 100%;
    object-fit: cover;
    background-size: cover;
    background-repeat: no-repeat;
    @media only screen and (min-width: 275px) and (max-width: 480px) {
         width: 100%   
         object-fit: cover;
         height: 226px;
         background-size: cover;
         background-repeat: no-repeat;
     }
`;

export default ContentWrapper;
